import SampleProduct from 'components/GlobalModals/ProductSamplesModal/SampleProduct/SampleProduct';

export default SampleProduct;
